// dataRightsCopy.ts — UI copy for the Data Rights admin panel.
//
// All strings here. Keeps ControlsPage.tsx free of inline literals.
// Brand voice: no exclamation marks, title case for headings,
// sentence case for buttons, factual error phrasing.

export const DATA_RIGHTS_COPY = {
  // Section
  sectionTitle: 'Data Rights',
  sectionSubtitle:
    'Fulfill access, deletion, and complaint requests per the privacy policy.',

  // Sub-panel A: email → Stripe lookup
  lookupTitle: 'Look Up User by Email',
  lookupSubtitle:
    'Resolve a Stripe customer from the email address the user provided.',
  emailLabel: 'Email address',
  emailPlaceholder: 'user@example.com',
  lookupButton: 'Look up Stripe customer',
  lookupLoading: 'Looking up.',
  lookupEmpty: 'No Stripe customers found for that email.',
  lookupError: 'Stripe lookup failed. Check the email and try again.',
  resolveButton: 'Resolve principal',
  resolving: 'Resolving.',
  resolveNotLinked: 'No Dominus account is linked to this Stripe customer.',

  // Sub-panel B: principal → export
  exportTitle: 'Export User Data',
  exportSubtitle:
    'Download a JSON bundle of all data held for a given principal. An audit log entry is created automatically.',
  principalLabel: 'Principal',
  principalPlaceholder: 'aaaaa-aa…',
  principalHelp: 'Paste directly or resolve from Sub-panel A.',
  exportButton: 'Export user data',
  exportLoading: 'Exporting.',
  exportSuccess: 'User data exported. Audit log entry created.',
  exportError: 'Export failed. The canister may be unreachable.',

  // Sub-panel C: log privacy event
  logTitle: 'Log Privacy Event',
  logSubtitle:
    'Record an accountability entry for a rights request, complaint, or security disclosure.',
  actionTypeLabel: 'Event type',
  targetPrincipalLabel: 'Principal (optional)',
  targetPrincipalHelp: 'Leave empty for events without an associated user (e.g. security disclosures).',
  detailsLabel: 'Details',
  detailsPlaceholder: 'Describe the event and any action taken.',
  detailsHelp: 'Maximum 1000 characters.',
  logButton: 'Record event',
  logLoading: 'Recording.',
  logSuccess: 'Privacy event logged.',
  logError: 'Failed to record privacy event.',
} as const;
